// import { Icd10CodeRequest } from './../model/clinical-reviewer/icd10-code-request';
// import { LabsAndImaging } from './../model/clinical-reviewer/labs-and-imaging';
// import { Icd10Code } from './../model/clinical-reviewer/icd10-code';
// import { Screening } from './../model/clinical-reviewer/screening';
import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { AssignmentQueue } from '../model/assignment-portal/assignment-portal';
import { AssignmentQueuePageRequest } from '../model/assignment-portal/assignment-portal-page-request';
import { AssignmentQueueRequest } from '../model/assignment-portal/assignment-queue-request';

@Injectable({
  providedIn: 'root'
})
export class AssignmentPortalService {

  private baseUrl: string;
  private voiceUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.cpApiUrl;
  }
  public getDefaultData(): Observable<any> {
    console.log("Get all data..");
    const headers = new HttpHeaders()
        .set('Content-Type', 'application/json');
    return this.http.get<AssignmentQueue[]>(this.baseUrl.concat("/codingManager"), { headers: headers });
}
public getMemberData(memberId: string): Observable<any> {
  console.log("Get all data..");
  const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
  return this.http.get<AssignmentQueue[]>(this.baseUrl.concat("/codingManager/")
      .concat(memberId), { headers: headers });

}
  public getCoderList(assignmentQueuePageRequest: AssignmentQueuePageRequest): Observable<any> {
    console.log("Get all coder data..");
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
    return this.http.post<AssignmentQueue[]>(this.baseUrl.concat("/assignment/"), assignmentQueuePageRequest, { headers: headers });
  }

  public getAllAssignmentQueueListData(assignmentQueuePageRequest: AssignmentQueuePageRequest): Observable<any> {
    console.log("Get all members data..");
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');   
    return this.http.post<AssignmentQueue[]>(this.baseUrl.concat("/assignment/"), assignmentQueuePageRequest, { headers: headers });
  }

  public getAssignmentQueueListData(assignmentQueuePageRequest: AssignmentQueuePageRequest): Observable<any> {
    console.log("Get all members data..");
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');  
    return this.http.post<AssignmentQueue[]>(this.baseUrl.concat("/assignment/"), assignmentQueuePageRequest, { headers: headers });
  }

  public getAssignmentQueueListDataByScheduledDate(assignmentQueuePageRequest: AssignmentQueuePageRequest): Observable<any> {
    console.log("Get all members data..");
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');  
    return this.http.post<AssignmentQueue[]>(this.baseUrl.concat("/assignment"), assignmentQueuePageRequest, { headers: headers });
  }

  public getAssignmentQueueListDataBySearchKey(assignmentQueuePageRequest: AssignmentQueuePageRequest): Observable<any> {
    console.log("Get all members data..");
    const headers = new HttpHeaders()
    return this.http.post<AssignmentQueue[]>(this.baseUrl.concat("/assignment/search"), assignmentQueuePageRequest, { headers: headers });
  }
  public save(assignmentQueue: AssignmentQueue) {
    return this.http.post<AssignmentQueue>(this.baseUrl.concat("/assignment/"), assignmentQueue);
  }

  public getAssignmentQueuesListData(memberId: string): Observable<any> {
    console.log("Get Member details..");
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
    return this.http.get<AssignmentQueue>(this.baseUrl.concat("/assignments/")
      .concat(memberId), { headers: headers });
  }
  public saveManageCoder(assignmentQueueRequest: AssignmentQueueRequest): Observable<any> {
    console.log("Save Manager Coder details..");
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
    return this.http.post<AssignmentQueue[]>(this.baseUrl.concat("/assignment/save")
      ,assignmentQueueRequest, { headers: headers });
  }
}
